import React from 'react';
import { FilePlus2 } from 'lucide-react';

const VineyardsListToolbar = ({ onAddVineyard }) => {
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <h5 className="mb-0">Vineyards</h5>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-primary"
                                onClick={onAddVineyard}
                                title="Add New Vineyard"
                            >
                                <FilePlus2 size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default VineyardsListToolbar;